import * as fabric from 'office-ui-fabric-react';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as api from '../../../../api/generated';
import PageHeader from '../../../../components/layout/PageHeader';
import { WaitingTimesWarningType } from '../../../../enums';
import GeneralSettingsDebts from './debts/GeneralSettingsDebts';
import GeneralSettingsDesign from './design/GeneralSettingsDesign';
import GeneralSettingsTerminalsAdministration from './terminals/GeneralSettingsTerminalsAdministration';
import GeneralSettingsTicketsTemplates from './ticketTemplates/GeneralSettingsTicketsTemplates';
import GeneralSettingsUsersWarning from './userWarnings/GeneralSettingsUsersWarning';
import GeneralSettingsVisitsTime from './visitTime/GeneralSettingsVisitsTime';

export interface ISettings {
    generalActiveTicketPrintingTimeAfterVisit: number;
    generalActiveTicketPrintingTimeBeforeVisit: number;
    isGeneralPrintingTimeBeforeVisitEnabled: boolean;
    isGeneralPrintingTimeAfterVisitEnabled: boolean;
    isTimeManagementFunctionActive: boolean;
    arrivalTimeBetweenFloors: number;
    arrivalTimeBetweenFloorsCoefficient: number;
    isDeptManagemenetEnabled: boolean;
    deptAppliesFromValue: number;
    authenticatedUserSessionTimeInTerminal: number;
    terminalsAdminKey: string | null;
    usersWarningOfDevicesEmails: IUserEmail[];
    usersWarningOfWaitingTimes: IUserWaitingTime[];
}

export interface IUserEmail {
    id: number;
    email: string | null;
}

export interface IUserWaitingTime extends IUserEmail {
    serviceId: number | null;
    serviceName: string | null;
    locationId: number | null;
    locationName: string | null;
    patientWaitingTime: number;
    patientAttendanceTime: number;
    waitingTimesWarningType: WaitingTimesWarningType;
}

const GeneralSettingsPage: FC = () => {
    const [settings, setSettings] = useState<ISettings | null>(null);
    const { organizationInformationId } = useParams<'organizationInformationId'>();
    const isCancelled = React.useRef(false);

    const fetchData = async () => {
        api.administration.getOrganizationGeneralSettings(parseInt(organizationInformationId.toString())).then((resp) => {
            if (!isCancelled.current) {
                setSettings(resp);
            }
        });
    };

    useEffect(() => {
        fetchData();

        return () => {
            isCancelled.current = true;
        };
    }, []);

    return (
        <div>
            <PageHeader text="Bendri nustatymai" />
            <fabric.Pivot>
                <fabric.PivotItem headerText="Laiko valdymas">
                    <GeneralSettingsVisitsTime fetchData={fetchData} settings={settings} />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Dizainas">
                    <GeneralSettingsDesign />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Skolų valdymas">
                    <GeneralSettingsDebts fetchData={fetchData} settings={settings} />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Naudotojų įspėjimas">
                    <GeneralSettingsUsersWarning fetchData={fetchData} settings={settings} />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Bilietų šablonai">
                    <GeneralSettingsTicketsTemplates />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Terminalų nustatymai">
                    <GeneralSettingsTerminalsAdministration fetchData={fetchData} settings={settings} />
                </fabric.PivotItem>
            </fabric.Pivot>
        </div>
    );
};
export default GeneralSettingsPage;
